import React from 'react';
import PubSub from "services/PubSub";

const ButtonsLogin = ({close}) => {

    const goLogin = () => {
        close();
    
        PubSub.dispatch('login_open');
    }
    
    const goRegister = () => {
        close();
        PubSub.dispatch('register_open');
    }

    return (
        <div className="delivery-selector-actions">
            <button type="button" className="new-link flat-btn btn-link" onClick={goRegister}>
                Regístrate
            </button>
            <button type="submit" className="new-link flat-btn btn-link" onClick={goLogin}>
                Ingresa
            </button>
        </div>
    )
}

export default ButtonsLogin;